import {
  changeDevicesWiFiDTO,
  defaultOptions,
  Device,
  DeviceMoveDTO,
  DeviceResidentDTO,
  DeviceSocketUpdateDTO,
  devicesReqOptions,
  DevicesSettings,
  DeviceType,
  DeviceUpdateDTO,
  userTagSettingsDTO,
  userTagUpdateSocketDTO,
} from ".";
import {
  DeviceStatus,
  setUserNearbyDeviceSettingsDTO,
} from "../devicesStatuses";
import { MoveResidentWithDeviceResponceDTO } from "../residents";
import {
  DEVICES,
  IAddDeviceBySocket,
  IChangeDeviceClear,
  IChangeDeviceFailure,
  IChangeDeviceRequest,
  IChangeDevicesSelected,
  IChangeDeviceSuccess,
  IChangeDevicesWifiFailure,
  IChangeDevicesWifiRequest,
  IChangeDevicesWifiSuccess,
  IChangeUserNearbyAlertSettingsBySocket,
  IChangeUserNearbyAlertSettingsFailure,
  IChangeUserNearbyAlertSettingsRequest,
  IChangeUserNearbyAlertSettingsSuccess,
  IChangeUserNearbyDeviceSettingsBySocket,
  IDeleteDeviceBySocket,
  IGetAllDevicesStatusesFailure,
  IGetAllDevicesStatusesRequest,
  IGetAllDevicesStatusesSuccess,
  IGetDevicesFailure,
  IGetDevicesRequest,
  IGetDevicesSuccess,
  IGetDeviceStatusBySoket,
  IGetDeviceStatusesFailure,
  IGetDeviceStatusesRequest,
  IGetDeviceStatusesSuccess,
  IGetOneDeviceRequest,
  IGetOneDevicesFailure,
  IGetOneDevicesSuccess,
  IGetUserNearbyFailure,
  IGetUserNearbyRequest,
  IGetUserNearbySettingsFailure,
  IGetUserNearbySettingsRequest,
  IGetUserNearbySettingsSuccess,
  IGetUserNearbySuccess,
  IGetUserTagDevicesFailure,
  IGetUserTagDevicesRequest,
  IGetUserTagDevicesSuccess,
  IMoveManyDeviceFailure,
  IMoveManyDeviceRequest,
  IMoveManyDeviceSuccess,
  IMoveResidentWithDevicesSuccess_Devices,
  ISetDevicesSettings,
  ISetUserNearbySettingsFailure,
  ISetUserNearbySettingsRequest,
  ISetUserNearbySettingsSuccess,
  IUpdateDeviceBySocket,
} from "./types";
export function getDevices(
  options: devicesReqOptions,
  blocking = true
): IGetDevicesRequest {
  return {
    type: DEVICES.GET_DEVICES_REQUEST,
    payload: {
      options: options !== undefined ? options : defaultOptions,
      blocking,
    },
  };
}
export function getDevicesSussess(value: any[]): IGetDevicesSuccess {
  return { type: DEVICES.GET_DEVICES_SUCCESS, payload: value };
}
export function getDevicesFailure(value: any): IGetDevicesFailure {
  return { type: DEVICES.GET_DEVICES_FAILURE, payload: { value } };
}

export function getUserTagDevices(
  options: devicesReqOptions,
  blocking = true
): IGetUserTagDevicesRequest {
  return {
    type: DEVICES.GET_USER_TAG_DEVICES_REQUEST,
    payload: {
      options: options !== undefined ? options : defaultOptions,
      blocking,
    },
  };
}
export function getUserTagDevicesSussess(
  value: any[]
): IGetUserTagDevicesSuccess {
  return { type: DEVICES.GET_USER_TAG_DEVICES_SUCCESS, payload: value };
}
export function getUserTagDevicesFailure(
  value: any
): IGetUserTagDevicesFailure {
  return { type: DEVICES.GET_USER_TAG_DEVICES_FAILURE, payload: { value } };
}

export function getOneDevice(deviceId: string): IGetOneDeviceRequest {
  return { type: DEVICES.GET_ONE_DEVICE_REQUEST, payload: { deviceId } };
}
export function getOneDeviceSussess(device: Device): IGetOneDevicesSuccess {
  return { type: DEVICES.GET_ONE_DEVICE_SUCCESS, payload: { device } };
}
export function getOneDeviceFailure(value: any): IGetOneDevicesFailure {
  return { type: DEVICES.GET_ONE_DEVICE_FAILURE, payload: { value } };
}

export function getDeviceStatuses(
  deviceId: string,
  deviceType: DeviceType
): IGetDeviceStatusesRequest {
  return {
    type: DEVICES.GET_DEVICE_STATUSES_REQUEST,
    payload: { deviceId, deviceType },
  };
}
export function getDeviceStatusesSussess(
  statuses: DeviceStatus[],
  deviceId: string
): IGetDeviceStatusesSuccess {
  return {
    type: DEVICES.GET_DEVICE_STATUSES_SUCCESS,
    payload: { statuses, deviceId },
  };
}
export function getDeviceStatusesFailure(
  value: any
): IGetDeviceStatusesFailure {
  return { type: DEVICES.GET_DEVICE_STATUSES_FAILURE, payload: { value } };
}

export function getAllDevicesStatuses(
  options: devicesReqOptions
): IGetAllDevicesStatusesRequest {
  return { type: DEVICES.GET_ALL_DEVICES_STATUSES_REQUEST, payload: options };
}
export function getAllDevicesStatusesSussess(
  value: any
): IGetAllDevicesStatusesSuccess {
  return { type: DEVICES.GET_ALL_DEVICE_STATUSES_SUCCESS, payload: value };
}
export function getAllDevicesStatusesFailure(
  value: any
): IGetAllDevicesStatusesFailure {
  return { type: DEVICES.GET_ALL_DEVICE_STATUSES_FAILURE, payload: { value } };
}

export function setDevicesSettings(
  type: DeviceType,
  value: DevicesSettings
): ISetDevicesSettings {
  return { type: DEVICES.SET_SETTINGS, payload: { type, value } };
}

export function changeDevicesSelected(
  type: DeviceType,
  value: string
): IChangeDevicesSelected {
  return { type: DEVICES.CHANGE_SELECTED, payload: { type, value } };
}

export function changeDevice(value: DeviceUpdateDTO): IChangeDeviceRequest {
  return { type: DEVICES.CHANGE_DEVICE_REQUEST, payload: value };
}
export function changeDeviceSussess(
  value: DeviceUpdateDTO
): IChangeDeviceSuccess {
  return { type: DEVICES.CHANGE_DEVICE_SUCCESS, payload: value };
}
export function changeDeviceFailure(value: any): IChangeDeviceFailure {
  return { type: DEVICES.CHANGE_DEVICE_FAILURE, payload: value };
}

export function changeDeviceClear(): IChangeDeviceClear {
  return { type: DEVICES.CLEAR_SUCCESS_STATE };
}

export function moveManyDevices(
  value: DeviceMoveDTO[]
): IMoveManyDeviceRequest {
  return { type: DEVICES.MOVE_MANY_DEVICE_REQUEST, payload: value };
}
export function moveManyDevicesSussess(
  value: DeviceMoveDTO[]
): IMoveManyDeviceSuccess {
  return { type: DEVICES.MOVE_MANY_DEVICE_SUCCESS, payload: value };
}
export function moveManyDevicesFailure(value: any): IMoveManyDeviceFailure {
  return { type: DEVICES.MOVE_MANY_DEVICE_FAILURE, payload: value };
}

export function moveResidentWithDevicesSuccess_devices(
  value: MoveResidentWithDeviceResponceDTO[]
): IMoveResidentWithDevicesSuccess_Devices {
  return { type: DEVICES.MOVE_RESIDENT_WITH_DEVICES_SUCCESS, payload: value };
}

export function updateDeviceBySocket(
  value: DeviceSocketUpdateDTO
): IUpdateDeviceBySocket {
  return { type: DEVICES.UPDATE_DEVICE_BY_SOCKET, payload: value };
}

export function addDeviceBySocket(
  value: DeviceSocketUpdateDTO
): IAddDeviceBySocket {
  return { type: DEVICES.ADD_DEVICE_BY_SOCKET, payload: value };
}

export function deleteDeviceBySocket(
  value: DeviceResidentDTO
): IDeleteDeviceBySocket {
  return { type: DEVICES.DELETE_DEVICE_BY_SOCKET, payload: value };
}

export function getDeviceStatusBySoket({
  deviceId,
  status,
}: {
  status: DeviceStatus;
  deviceId: string;
}): IGetDeviceStatusBySoket {
  return {
    type: DEVICES.GET_DEVICE_STATUS_BY_SOCKET,
    payload: { deviceId, status },
  };
}

export function getVitalsUserNearby(): IGetUserNearbyRequest {
  return {
    type: DEVICES.GET_USER_NEARBY_REQUEST,
  };
}
export function getVitalsUserNearbySussess(value: any): IGetUserNearbySuccess {
  return { type: DEVICES.GET_USER_NEARBY_SUCCESS, payload: value };
}
export function getVitalsUserNearbyFailure(value: any): IGetUserNearbyFailure {
  return { type: DEVICES.GET_USER_NEARBY_FAILURE, payload: { value } };
}

export function changeUserNearbyAlertSettings(
  value: userTagSettingsDTO[]
): IChangeUserNearbyAlertSettingsRequest {
  return {
    type: DEVICES.CHANGE_USER_NEARBY_ALERT_SETTINGS_REQUEST,
    payload: value,
  };
}
export function changeUserNearbyAlertSettingsSussess(
  value: userTagSettingsDTO[]
): IChangeUserNearbyAlertSettingsSuccess {
  return {
    type: DEVICES.CHANGE_USER_NEARBY_ALERT_SETTINGS_SUCCESS,
    payload: value,
  };
}
export function changeUserNearbyAlertSettingsFailure(
  value: any
): IChangeUserNearbyAlertSettingsFailure {
  return {
    type: DEVICES.CHANGE_USER_NEARBY_ALERT_SETTINGS_FAILURE,
    payload: { value },
  };
}

export function changeUserNearbyAlertSettingsBySocket(
  value: userTagUpdateSocketDTO
): IChangeUserNearbyAlertSettingsBySocket {
  return {
    type: DEVICES.CHANGE_USER_NEARBY_ALERT_SETTINGS_BY_SOCKET,
    payload: value,
  };
}

export function getVitalsSettingsUserNearby(): IGetUserNearbySettingsRequest {
  return {
    type: DEVICES.GET_USER_NEARBY_SETTINGS_REQUEST,
  };
}
export function getVitalsSettingsUserNearbySussess(
  value: any
): IGetUserNearbySettingsSuccess {
  return { type: DEVICES.GET_USER_NEARBY_SETTINGS_SUCCESS, payload: value };
}
export function getVitalsSettingsUserNearbyFailure(
  value: any
): IGetUserNearbySettingsFailure {
  return { type: DEVICES.GET_USER_NEARBY_SETTINGS_FAILURE, payload: { value } };
}

export function setVitalsSettingsUserNearby(
  value: setUserNearbyDeviceSettingsDTO
): ISetUserNearbySettingsRequest {
  return {
    type: DEVICES.SET_USER_NEARBY_SETTINGS_REQUEST,
    payload: value,
  };
}
export function setVitalsSettingsUserNearbySussess(
  value: userTagSettingsDTO
): ISetUserNearbySettingsSuccess {
  return { type: DEVICES.SET_USER_NEARBY_SETTINGS_SUCCESS, payload: value };
}
export function setVitalsSettingsUserNearbyFailure(
  value: any
): ISetUserNearbySettingsFailure {
  return { type: DEVICES.SET_USER_NEARBY_SETTINGS_FAILURE, payload: { value } };
}

export function setVitalsSettingsUserNearbyBySocket(
  value: setUserNearbyDeviceSettingsDTO
): IChangeUserNearbyDeviceSettingsBySocket {
  return {
    type: DEVICES.CHANGE_USER_NEARBY_DEVICE_SETTINGS_BY_SOCKET,
    payload: value,
  };
}

export function changeDevicesWifi(
  value: changeDevicesWiFiDTO
): IChangeDevicesWifiRequest {
  return {
    type: DEVICES.CHANGE_DEVICES_WIFI_REQUEST,
    payload: value,
  };
}
export function changeDevicesWifiSussess(
  value: userTagSettingsDTO
): IChangeDevicesWifiSuccess {
  return { type: DEVICES.CHANGE_DEVICES_WIFI_SUCCESS, payload: value };
}
export function changeDevicesWifiFailure(
  value: any
): IChangeDevicesWifiFailure {
  return { type: DEVICES.CHANGE_DEVICES_WIFI_FAILURE, payload: { value } };
}
